import { equals } from 'ramda';

import stubUndefined from './stubUndefined';

/**
 * Checks if input value is `undefined`.
 *
 * @func isUndefined
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.0.1|v0.0.1}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {Boolean}
 * @see {@link RA.isNotUndefined|isNotUndefined}
 * @example
 *
 * RA.isUndefined(1); //=> false
 * RA.isUndefined(undefined); //=> true
 * RA.isUndefined(null); //=> false
 */
var isUndefined = /*#__PURE__*/equals( /*#__PURE__*/stubUndefined());

export default isUndefined;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/isUndefined.js
// module id = 138
// module chunks = 0